module.exports = __webpack_public_path__ + "img/LSIL.6c03cb3f.png";